import { Typography, TypographyProps } from '@material-ui/core'
import React from 'react'
import { WorkingStepType } from 'services/APIs/InternalAPI/internal-api.contracts'
import { useLocalizedWorkingStepLabel } from './useLocalizedWorkingStepLabel'

type Props = {
  workingStepType: WorkingStepType
  component?: string
} & TypographyProps

export const LocalizedWorkingStepLabel = (props: Props) => {
  const { workingStepType, ...typographyProps } = props

  const { getLocalizedWorkingStep } = useLocalizedWorkingStepLabel()

  return (
    <Typography {...(typographyProps || {})}>
      {getLocalizedWorkingStep(workingStepType)}
    </Typography>
  )
}
